// extracted by mini-css-extract-plugin
export default {"cls1":"AiSummary-cls1_m04","cls2":"AiSummary-cls2__4h AiSummary-cls1_m04"};